import type { ResultOf } from '@graphql-typed-document-node/core';

import { graphql } from '@e-socna/data-layer';

import { useGraphQLMutation } from '../../../hooks/useGraphQLMutation.hook';

export const ResolvableServiceForm_ResolvableService_Foau_Mutation = graphql(`
  mutation ResolvableServiceForm_ResolvableService_Foau(
    $filter: IdFilterInput!
    $update: ResolvableServiceInput!
    $versionData: VersionDataInput
  ) {
    findOneAndUpdateResolvableService(
      filter: $filter
      update: $update
      versionData: $versionData
    ) {
      _id
    }
  }
`);

export type ResolvableServiceForm_ResolvableService_Foau_Result = ResultOf<
  typeof ResolvableServiceForm_ResolvableService_Foau_Mutation
>;

export const useUpdateResolvableServiceMutation = () =>
  useGraphQLMutation(ResolvableServiceForm_ResolvableService_Foau_Mutation);
